// importing core libraries
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// importing third party libraries
import { IoClose } from "react-icons/io5";
import { FaStar } from "react-icons/fa";
import { ClipLoader } from "react-spinners";

//importing custom hooks
import { useThunk } from "../../hooks/useThunk.js";
import  useForm  from "../../hooks/useForm.js";

// importing assets
import attachicon from "../../assets/Thread/Attach.svg";
import sendicon from "../../assets/Thread/Send.svg";
import icon from "../../assets/Thread/@.svg";
import waiting from "../../assets/Thread/nomessages.jpg";

//importing components
import ArrowButton from "../../components/Form/ArrowButton";
import Input from "../../components/Form/Inputfield";
import DragUpload from "../Form/DragUpload";
import SystemMessage from "./SystemMessage";
import CustomFileIcon from "../CustomFileIcon.jsx";
import LoginButton from "../Form/LoginButton";
import LoginInput from "../Form/LoginInput.jsx";
import Checkbox from "../Form/Checkbox";

// import dispatchers, thunks, functions, utills
import {
    acceptOrder,
    clearThreadChats,
    fetchThreadById,
    fetchUserThreadChats,
    fetchUserThreadSystemNotifications,
    requestRevision,
    setBulkThreads,
    setSelectedChatsPage,
    setSelectedFormType,
    setThreadBulkChats,
} from "../../store";
import { getTokenPayload } from "../../utils/getTokenPayload";
import showToast from "../../utils/toastNotifications.js";
import {
    formatHH_MM_SS,
    formatOrderCreatedDate,
    formatYYYY_MM_DD,
    formatYYYY_MM_DD_HH_MM_A,
} from "../../utils/dateFormating.js";
import {
    groupMessagesByDate,
    sortGroupdArray,
} from "../../utils/groupMessagesByDate.js";
import { orderStatus, roles, systemNotifications } from "../../constants/commonConstants.js";
import useFirebaseFileUpload from "../../hooks/useFirebaseFileUpload.js";
import { getFileExtension } from "../../utils/getFileExtension.js";
import { USER_INPUT_FIELD_TYPES } from "../../constants/userInputFieldNames.js";
import { currencyFormatter } from "../../utils/formatting.js";
import { twMerge } from "tailwind-merge";

// const values
const SIZE = 5000;

const MessageList = ({
    socket,
    roleRef,
    userIdRef,
    selectedThreadRef,
    threasdsRef,
    chatRef,
    roomIdSearchParam,
    threadIdSearchParam,
    refetchSelectedThreadAndOrderFromQueryParams,
    refetchSelectedThreadAndOrder,
    isFetchUserOrderByRoomId = false,
    isFetchThreadById = false,
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tokenPayload = getTokenPayload();
    const thread = useSelector((state) => state.thread);    

    /* === > defining local states <=== */
    const messageEndRef = useRef(null);
    const [selectedReveision, setSlectedReveision] = useState(null)
    const multipleRevisions = []
        
    /* ------- CHATTING RELATED LOCAL STATES ---------- */
    const [groupedInboxMessagesByDate, setGroupedInboxMessagesByDate] = useState(groupMessagesByDate(thread?.selectedThreadChat));
    const [text, setText] = useState("");    
    // State to store deliver documents
    const [uploadFiles, setUploadFiles] = useState([]);
    
    // chat pagination
    const [pagination, setPagination] = useState({
        page: 1,
        size: SIZE,
    });
    
    // getting custom hooks
    const [
        doFetchUserThreadChats,
        isFetchUserThreadChatsLoading,
        fetchUserThreadChatsError,
    ] = useThunk(fetchUserThreadChats);
    
    const [
        doFetchUserThreadSystemNotifications,
        isFetchUserThreadSystemNotificationsLoading,
        fetchUserThreadSystemNotificationsError,
    ] = useThunk(fetchUserThreadSystemNotifications);
    
    const [
        doRequestRevision,
        isRequestRevision,
        errorRequestRevision,
    ] = useThunk(requestRevision);

    const [
        doAcceptOrder,
        isAcceptOrder,
        errorAcceptOrder,
    ] = useThunk(acceptOrder);
    
    // uploading files
    const [
        doUploadRefrencesToFirebase,
        isUploadRefrencesToFirebaseLoading,
        uploadRefrencesToFirebaseError,
    ] = useFirebaseFileUpload();
    
    // accept order propterties
    const [rating, setRating] = useState(4);
    const [feedback, setFeedback] = useState("");

    // request revision form properties ====================================================>
    const {
        formData,
        errors,
        touched,
        handleInputChange,
        handleBlur,
        validateForm,
        setTouched,
        setFormData,
    } = useForm(
        {
            requestRevisionRequirements: "",
        },
        {
            requestRevisionRequirements: true
        },
        {
            requestRevisionRequirements: USER_INPUT_FIELD_TYPES.REQUIRED_FIELD,

        }
    );

    // fetch system notifications
    useEffect(() => {
        if (thread?.selectedThreadId) {
            fetchUserThreadSystemNotificationsMethod();
            setUploadFiles([]);
        }
    }, [thread?.selectedThreadId]);

    // fetch user threads accroding to paginatin modal
    useEffect(() => {
        fetchUserThreadChatsMethod();
        setUploadFiles([]);
    }, [thread?.selectedThreadId, thread?.selectedThread, pagination]);

    useEffect(() => {setUploadFiles([])}, [thread?.selectedFormType]);

    // If a request is made to open the accept order form or revision request form regardless of that particular operation completed already; Returns back to the System Messages section
    useEffect(() => {
        if(thread?.selectedFormType === "request-revision" && thread?.selectedOrder?.status === orderStatus.IN_REVISION){
            dispatch(setSelectedFormType("system"));
        }else if(thread?.selectedFormType === "accept-order" && thread?.selectedOrder?.status === orderStatus.COMPLETED){
            dispatch(setSelectedFormType("system"));
        }
    }, [thread?.selectedFormType])

    // automatically scroll down to the bottom of the message container
    useEffect(() => {        
        if (messageEndRef.current) {
            // messageDivRef.current.scrollTop = messageDivRef.current.scrollHeight;
            messageEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    });

    /*
     *
     * ===================== CHATTING RELATED SIDE EFFECTS DEFINITIONS =============================================================================
     *
    */

    // groupingna dsorting inbox messages/chats y date
    useEffect(() => {
        setGroupedInboxMessagesByDate(groupMessagesByDate(thread?.selectedThreadChat));
        setUploadFiles([]);
    }, [thread?.selectedThreadChat])

    /*
     *
     * I/O HANDLING METHODS/ SUBMIT METHODS AND OTHER UTILITY METHODS ================================================>
     *
     */

    // Button click for system messages
    const handleButtonClick = (formType, revisionReference) => {
        
        if(formType === "pay-now"){
            navigate(`/secure-payment/${thread?.selectedOrder?._id}`);
        }

        // revision reference will be a object for a deliverable reference or will be a strign for revision reference
        if(revisionReference && typeof revisionReference === 'string'){
            setSlectedReveision(multipleRevisions?.filter(it => it?._id === revisionReference)[0]);
        }else if(revisionReference && typeof revisionReference === 'object'){
            setSlectedReveision(revisionReference)
        }

        dispatch(setSelectedFormType(formType));
    };

    const handleDragUpload = (uploadedFiles) => {
        // Handle file uploads
        setUploadFiles((prev) => [...prev, ...uploadedFiles]);
    };

    // method to be used to send inbox messages
    const handleSendMessage = async() => {
        
        let downloadURLs = [];
        
        if(uploadFiles?.length > 0){
            const fileUploadResult = await doUploadRefrencesToFirebase(uploadFiles, "message");            
            if (!fileUploadResult.success) {
                showToast("error", "Failed to upload attachments");
                showToast("error", fileUploadResult?.error?.message || "Failed to upload files");
            }else{
                downloadURLs = fileUploadResult?.uploadedUrls || [];                
            }
        }

        if ((text && text.toString().trim().length > 0) || (uploadFiles?.length > 0)) {    

            socket.emit('message', {
                roomId: thread?.selectedThread?._id || '', 
                userId: userIdRef ? userIdRef.current : '', 
                text: text, 
                role: roleRef ? (roleRef.current)?.toLowerCase() : '', 
                files: downloadURLs || []
                // mentionedList: currentMentionedUsersRef.current
            });
            setText("");
            setUploadFiles([]);
            // setCurrentMentionedUsers([]);
            // if(currentMentionedUsers.current){
            //     currentMentionedUsers.current = [];
            // }
        }
    };

    // request revision submission
    const handleRequestRevision = async() => {
        // Mark all fields as touched       
        setTouched({requestRevisionRequirements: true});

        if (!validateForm()) {
            showToast("error", "Please fill all required fields");
            return;
        }else {
            requestRevisionMethod();
        }

        // else if(uploadFiles?.length < 1){
        //     showToast("error", "Please Upload the Deliverables");
        //     return;
        // }
    }

    // submit request revision
    const requestRevisionMethod = async() => {

        const fileUploadResult = await doUploadRefrencesToFirebase(
            uploadFiles,
            "request-revisions"
        );

        if (!fileUploadResult.success) {
            console.error("Upload Error:", fileUploadResult.error);
            showToast("error", fileUploadResult?.error?.message || "Failed to upload files");
            return;
        }

        const downloadURLs = fileUploadResult.uploadedUrls;

        
        const requestRevisionData = {
            ...formData,
            requirements: formData.requestRevisionRequirements,
            orderId: thread?.selectedOrder?._id,
            documents: downloadURLs,
        };

        // Call the request revision thunk
        const result = await doRequestRevision(requestRevisionData);

        if (result?.success) {

            // refetch the thread and order details in order to update-rerender UI elements, after a state changing operation of an order 
            // invoking methods based on if query parameters exists or if query parametrs does not exist
            // query paramerts exists if this thread page loaded from my order table : view order selected
            // query parametrs does not exist if this thread page loaded as general option
            if (roomIdSearchParam && threadIdSearchParam) {
                refetchSelectedThreadAndOrderFromQueryParams();
            } else {
                refetchSelectedThreadAndOrder();
            }

            showToast("success", "Revision Requested Successfully");
            setFormData({requestRevisionRequirements: ''});
            setUploadFiles([]);
            dispatch(setSelectedFormType("message"));
        } else {
            console.log("Error placing order", result?.error);
            showToast("error", result?.error?.message);
        }
    }

    // accept order submission
    const handleAcceptOrder = async() => {       
        const acceptOrderData = {
            orderId: thread?.selectedOrder?._id,
            customerFeedback : feedback,
            rating
        };

        // Call the accept order thunk
        const result = await doAcceptOrder(acceptOrderData);

        if (result?.success) {

            // refetch the thread and order details in order to update-rerender UI elements, after a state changing operation of an order 
            // invoking methods based on if query parameters exists or if query parametrs does not exist
            // query paramerts exists if this thread page loaded from my order table : view order selected
            // query parametrs does not exist if this thread page loaded as general option
            if (roomIdSearchParam && threadIdSearchParam) {
                refetchSelectedThreadAndOrderFromQueryParams();
            } else {
                refetchSelectedThreadAndOrder();
            }

            showToast("success", "Order Accepted Successfully");
            setRating(4);
            setFeedback('');
            dispatch(setSelectedFormType("message"));

        } else {
            console.log("Error placing order", result?.error);
            showToast("error", result?.error?.message);
        }
    }

    /*
     *
     * DATA FETCHING METHODS ================================================================================================>
     *
     */

    // Fetch all user thread chats
    const fetchUserThreadChatsMethod = async () => {
        try {
            const result = await doFetchUserThreadChats({
                page: pagination.page,
                size: pagination.size,
                threadId: thread?.selectedThreadId,
            });

            if (result.success) {

                chatRef.current = result?.response?.data?.chats;
                
                // clear the unread message count in client side: cleare the unread count of matching record; restore the record
                const prevThreads = thread?.threads;            
                const newThreads = prevThreads.map((threadParameter) => {
                    if(threadParameter?._id?.toString() === thread?.selectedThreadId?.toString()){                        
                        return {...threadParameter, lastRead: threadParameter?.lastRead?.map((item) => {                            
                            if(item?.userId?.toString() === userIdRef.current?.toString()){                                
                                return {...item, unreadCount: 0};
                            }
                            return item;
                        })}
                    }
                    return threadParameter;
                })
                threasdsRef.current = newThreads;
                dispatch(setBulkThreads(newThreads));
            }

            if (!result.success) {
                showToast("error", result.error?.message);
            }
        } catch {
            showToast("error", "Error occurred during fetching chats.");
        }
    };

    // Fetch all user thread system notifications
    const fetchUserThreadSystemNotificationsMethod = async () => {
        try {
            const result = await doFetchUserThreadSystemNotifications({
                threadId: thread?.selectedThreadId,
            });

            if (!result.success) {
                showToast("error", result.error?.message);
            }
        } catch {
            showToast("error", "Error occurred during fetching chats.");
        }
    };

    return (
        <div className="flex flex-col flex-grow h-[100%] mb-0 pb-12 overflow-auto scrollbar-none">
            {thread?.selectedFormType === "view-requirements" ? (
                <>
                    <div className="p-2 sm:p-[44px] flex justify-center flex-col relative bg-white rounded-md font-roboto ">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-center bg-light-blue py-3">
                            Requirement Summary
                        </h2>
                        <ul className="space-y-2 w-full border border-medium-gray p-6 rounde-[10px] font-medium">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5">
                                 <li className="text-secondary">
                                    Writing Type
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.writingType || "-"}
                                </li>
                                <li className="text-secondary">
                                    Type of Paper
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.typeOfPaper || "-"}
                                </li>
                                {/* <li className="text-secondary">
                                    Remove AI content
                                </li>
                                <li className="text-gray">
                                    <Checkbox
                                        name="removeAiContent"
                                        checked={thread?.selectedOrder?.orderRequirements?.removeAiContent}
                                        onChange={()=>{}}
                                        label="Humanize"
                                        containerStyle=""
                                    /> 
                                </li> */}
                                <li className="text-secondary">
                                    Academic Level
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.academicLevel || "-"}
                                </li>
                                <li className="text-secondary">
                                    Type of English
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.typeOfEnglish || "-"}
                                </li>
                                <li className="text-secondary">Deadline</li>
                                <li className="text-gray">
                                    {formatYYYY_MM_DD_HH_MM_A(
                                        thread?.selectedOrder?.orderRequirements
                                            ?.deadline || "-"
                                    )}
                                </li>
                                <li className="text-secondary">Spacing</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.spacing || "-"}
                                </li>
                                <li className="text-secondary">Pages</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.pages || "-"}
                                </li>
                                <li className="text-secondary">Slides</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.slides || "-"}
                                </li>
                                <li className="text-secondary">Subject</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.subject || "-"}
                                </li>
                                <li className="text-secondary">Topic</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.topic || "-"}
                                </li>
                                <li className="text-secondary">
                                    Reference Style
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.referenceStyle || "-"}
                                </li>
                                <li className="text-secondary">
                                    Reference Document
                                </li>
                                <li className="text-gray">
                                    {/* {thread?.selectedOrder?.orderRequirements
                                        ?.referenceDocument
                                        ? thread?.selectedOrder
                                            ?.orderRequirements
                                            ?.referenceDocument[0]
                                        : "-"} */}
                                    {
                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.length > 0 && (
                                            <>
                                                <div className="flex flex-row gap-2 flex-wrap mt-2">
                                                    {
                                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.length < 1 && '-'
                                    }
                                </li>
                            </ul>
                        </ul>
                    </div>
                </>
            ) : thread?.selectedFormType === "pay-now" ? (
                navigate("/secure-payment")
            ) : thread?.selectedFormType === "review-order" ? (
                <>
                    <div className="p-2 sm:p-[44px] relative flex justify-center flex-col  bg-white rounded-md  font-roboto ">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-center bg-light-blue py-3">
                            Review Order
                        </h2>
                        <ul className="space-y-2 w-full border border-medium-gray p-6 rounde-[10px] font-medium">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5">
                                <li className="text-secondary">Order ID</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.id || "-"}
                                </li>
                                <li className="text-secondary">
                                    Order Subject
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.topic || "-"}{" "}
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.subject || "-"}
                                </li>
                                <li className="text-secondary">
                                    Delivery Note
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderProgress?.includes(orderStatus.IN_REVISION) ? selectedReveision?.obj?.deliveryNotes || '-' : thread?.selectedOrder?.deliveryNotes || "-"}
                                </li>
                                <li className="text-secondary" onClick={console.log(selectedReveision)}>
                                    Final Submissions
                                </li>
                                <li className="text-gray">
                                    {   
                                        thread?.selectedOrder?.orderProgress?.includes(orderStatus.IN_REVISION) ?
                                        selectedReveision?.obj?.finalDeliverables?.length > 0 && (
                                            <>
                                                <div className="flex flex-row gap-2 flex-wrap mt-2">
                                                    {
                                                        selectedReveision?.obj?.finalDeliverables?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        ) || '-' :
                                        thread?.selectedOrder?.finalDeliverables?.length > 0 && (
                                            <>
                                                <div className="flex flex-row gap-2 flex-wrap mt-2">
                                                    {
                                                        thread?.selectedOrder?.finalDeliverables?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        ) || '-'
                                    }
                                    {
                                        thread?.selectedOrder?.orderProgress?.includes(orderStatus.IN_REVISION) ? selectedReveision?.obj?.finalDeliverables?.length < 1 && '-' : thread?.selectedOrder?.finalDeliverables?.length < 1 && '-'
                                    }
                                </li>
                            </ul>
                        </ul>
                    </div>
                </>
            ) : thread?.selectedFormType === "view-revision" ? (
                <>
                    <div className="p-2 relative sm:p-[44px] flex justify-center flex-col  bg-white rounded-md font-roboto ">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-center bg-light-blue py-3">
                            Revision Summary
                        </h2>
                        <ul className="space-y-2 w-full border border-medium-gray p-6 rounde-[10px] font-medium">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5">
                                <li className="text-secondary">Revision ID</li>
                                <li className="text-gray">
                                    {selectedReveision?.obj
                                        ?.id || "-"}
                                </li>
                                <li className="text-secondary">Requirements</li>
                                <li className="text-gray">
                                    {selectedReveision?.obj
                                        ?.requirements
                                        ? selectedReveision?.obj.requirements[0]
                                        : "-"}{" "}
                                </li>
                                <li className="text-secondary">
                                    Additional Documents
                                </li>
                                <li className="text-gray">
                                    {/* {thread?.selectedOrder?.revisions?.slice(-1)
                                        ?.documents
                                        ? thread?.selectedOrder?.revisions?.slice(
                                            -1
                                          )?.documents[0]
                                        : "-"} */}
                                    {
                                        selectedReveision?.obj?.documents?.length > 0 && (
                                            <>
                                                <div className="flex flex-row gap-2 flex-wrap mt-2">
                                                    {
                                                        selectedReveision?.obj?.documents?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        selectedReveision?.obj.documents?.length < 1 && '-'
                                    }
                                </li>
                            </ul>
                        </ul>
                    </div>
                </>
            ) : thread?.selectedFormType === "view-complaint" ? (
                <>
                    <div className="p-2 relative sm:p-[44px] flex justify-center flex-col  bg-white rounded-md  font-roboto ">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-0 sm:top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-center bg-light-blue py-3">
                            Complaint Summary
                        </h2>
                        <ul className="space-y-2 w-full  border border-medium-gray p-6 rounde-[10px] font-medium">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5">
                                <li className="text-secondary">Complaint ID</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.complaint?.id || "-"}
                                </li>
                                <li className="text-secondary">
                                    Complaint Date
                                </li>
                                <li className="text-gray">
                                    {formatYYYY_MM_DD(
                                        thread?.selectedOrder?.complaint
                                            ?.createdAt || "-"
                                    ) || "-"}{" "}
                                </li>
                                <li className="text-secondary">
                                    Complaint Subject
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.complaint
                                        ?.subject || "-"}
                                </li>
                                <li className="text-secondary">Description</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.complaint
                                        ?.description || "-"}
                                </li>
                                <li className="text-secondary">
                                    Preferred Solution
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.complaint
                                        ?.preferedResolution || "-"}
                                </li>
                                <li className="text-secondary">
                                    Contact Method
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.complaint
                                        ?.contactMethod || "-"}
                                </li>
                                <li className="text-secondary">
                                    Reference Document
                                </li>
                                <li className="text-gray">
                                    {/* {thread?.selectedOrder?.complaint
                                        ?.referenceDocument || "-"} */}
                                    {
                                        thread?.selectedOrder?.complaint?.referenceDocuments?.length > 0 && (
                                            <>
                                                <div className="flex flex-row gap-2 flex-wrap mt-2">
                                                    {
                                                        thread?.selectedOrder?.complaint?.referenceDocuments?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        thread?.selectedOrder?.complaint?.referenceDocuments?.length < 1 && '-'
                                    }
                                </li>
                            </ul>
                        </ul>
                    </div>
                </>
            ) : thread?.selectedFormType === "view-order" ? (
                <>
                    <div className="p-2 relative sm:p-[44px] flex justify-center flex-col  bg-white rounded-md font-roboto ">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-center bg-light-blue py-3">
                            Order Summary
                        </h2>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-start pt-3 ">
                            Order Details
                        </h2>
                        <ul className="space-y-2 w-full border border-medium-gray p-6 rounde-[10px] font-medium mb-4">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5">
                                <li className="text-secondary">Order ID </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.id || "-"}
                                </li>
                                <li className="text-secondary">
                                    Payment Receipt ID
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.paymentDetils?.id ||
                                        "-"}
                                </li>
                                <li className="text-secondary">
                                    Payment Method
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.paymentDetils
                                        ?.method || "-"}
                                </li>
                                <li className="text-secondary">Payment Date</li>
                                <li className="text-gray">
                                    {formatYYYY_MM_DD(
                                        thread?.selectedOrder?.paymentDetils
                                            ?.createdAt || "-"
                                    ) || "-"}
                                </li>
                                <li className="text-secondary">
                                    Total Payment
                                </li>
                                <li className="text-gray">
                                    {currencyFormatter.format(thread?.selectedOrder?.paymentDetils?.amount || 0) || "$ 00.00"}
                                </li>
                            </ul>
                        </ul>
                        <h2 className="text-lg font-bold mb-4 mt-2 font-roboto text-[18px] leading-5 text-primary text-start pt-3 ">
                            Order Requirements
                        </h2>
                        <ul className="space-y-2 w-full border border-medium-gray p-6 rounde-[10px] font-medium">
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 font-medium text-level-3 leading-5 mb-3">
                                <li className="text-secondary">
                                    Writing Type
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.writingType || "-"}
                                </li>
                                <li className="text-secondary">
                                    Type of Paper
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.typeOfPaper || "-"}
                                </li>
                                {/* <li className="text-secondary">
                                    Remove AI content
                                </li>
                                <li className="text-gray">
                                    <Checkbox
                                        name="removeAiContent"
                                        checked={thread?.selectedOrder?.orderRequirements?.removeAiContent}
                                        onChange={()=>{}}
                                        label="Humanize"
                                        containerStyle=""
                                    /> 
                                </li> */}
                                <li className="text-secondary">
                                    Academic Level
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.academicLevel || "-"}
                                </li>
                                <li className="text-secondary">
                                    Type of English
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.typeOfEnglish || "-"}
                                </li>
                                <li className="text-secondary">Deadline</li>
                                <li className="text-gray">
                                    {formatYYYY_MM_DD_HH_MM_A(
                                        thread?.selectedOrder?.orderRequirements
                                            ?.deadline || ""
                                    ) || "-"}
                                </li>
                                <li className="text-secondary">Spacing</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.spacing || "-"}
                                </li>
                                <li className="text-secondary">Pages</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.pages || "-"}
                                </li>
                                <li className="text-secondary">Slides</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.slides || "-"}
                                </li>
                                <li className="text-secondary">Subject</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.subject || "-"}
                                </li>
                                <li className="text-secondary">Topic</li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.topic || "-"}
                                </li>
                                <li className="text-secondary">
                                    Reference Style
                                </li>
                                <li className="text-gray">
                                    {thread?.selectedOrder?.orderRequirements
                                        ?.referenceStyle || "-"}
                                </li>
                                <li className="text-secondary">
                                    Reference Document
                                </li>
                                <li className="text-gray">
                                    {/* {thread?.selectedOrder?.orderRequirements
                                        ?.referenceDocument
                                        ? thread?.selectedOrder
                                            ?.orderRequirements
                                            ?.referenceDocument[0]
                                        : "-"} */}
                                    {
                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.length > 0 && (
                                            <>  {/* done */}
                                                <div className="flex flex-col gap-1 flex-wrap">
                                                    {
                                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.map((url, index) => {
                                                            return(
                                                                <>
                                                                    <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        thread?.selectedOrder?.orderRequirements?.referenceDocuments?.length < 1 && '-'
                                    }
                                </li>
                            </ul>
                            <div className="text-secondary mt-10 w-full">
                                <p className="">Order Instructions</p>
                                <div className="bg-slate-300 mt-1 h-[1px] w-full rounded-md"></div>
                                <pre className="lg:max-w-[48vw] 2xl:max-w-[60vw] mt-2 px-2 text-gray font-inter whitespace-pre-wrap break-words">{thread?.selectedOrder?.orderRequirements?.orderInstructions}</pre>
                            </div>
                        </ul>
                    </div>
                </>
            ) : thread?.selectedFormType === "accept-order" ? (
                <>
                    <div className="max-w-[800px] w-[100%] md:w-[70%] relative mx-auto flex flex-col items-center p-6 rounded-lg overflow-auto scrollbar-none">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-semibold mb-3 mt-2 font-roboto text-[20px] leading-5 text-primary text-center py-3">
                            Accept Order
                        </h2>

                        <p className="text-sm flex items-center font-inter text-secondary max-w-[600px]  text-center ">
                            Are you sure you want to accept this order? Once
                            accepted, no further revisions can be requested.
                        </p>

                        <div className="flex items-center justify-center mt-4 space-x-2 text-inter text-secondary">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    onClick={() => setRating(star)}
                                    className={`text-2xl  ${
                                        star <= rating
                                            ? "text-[#FBBF24]"
                                            : "text-gray"
                                    }`}
                                >
                                    <FaStar />
                                </button>
                            ))}
                            <span className="text-inter text-secondary text-level-4">
                                {rating}/5 stars
                            </span>
                        </div>

                        <textarea
                            placeholder="Leave feedback about the delivered work"
                            value={feedback}
                            onChange={(e) => {setFeedback(e.target.value)}}
                            className="w-full text-inter text-gray text-level-4 rounded-[5px] border border-medium-gray p-3 focus:outline-none mt-[32px] min-h-[166px]"
                            rows="4"
                        ></textarea>

                        <div className="flex w-full justify-between mt-6">
                            <ArrowButton
                                text="Back"
                                onClick={() => {}}
                                width="auto"
                                height="44px"
                                iconDirection="left"
                                iconPosition="before"
                                classname="mb-[25px]"
                            />
                            
                            <LoginButton
                                text={
                                    isAcceptOrder ? 
                                    <ClipLoader
                                        loading={true}
                                        speedMultiplier={0.5}
                                        size={22}
                                        color="#60a5fa"
                                    />
                                    : "Accept Order"}               
                                type="submit"
                                className="w-[80px] sm:w-[170px] h-[44px] flex items-center justify-center rounded-[5px] font-roboto text-[10px] sm:text-level-3 text-white font-semibold gap-[12px] px-[30px] py-[10px] transition-all duration-200"
                                onClick={() => {handleAcceptOrder()}}
                                disabled = {isAcceptOrder}
                            />
                        </div>
                    </div>
                </>
            ) : thread?.selectedFormType === "request-revision" ? (
                <>
                    <div className="max-w-[800px] w-[100%] md:w-[70%] relative mx-auto flex flex-col items-center px-6 pt-6 pb-0 rounded-lg overflow-auto scrollbar-none">
                        <button
                            className="text-blue-500 underline mt-4 absolute right-5 top-2"
                            onClick={() => {
                                dispatch(setSelectedFormType("system"));
                            }}
                        >
                            <IoClose className="w-[24px] h-auto text-secondary" />
                        </button>
                        <h2 className="text-lg font-semibold mb-3 mt-2 font-roboto text-[20px] leading-5 text-primary text-center py-3">
                            Request Revision
                        </h2>

                        <p className="text-level-4 flex items-center font-inter text-secondary max-w-[600px]  text-center mb-[42px] ">
                            Specify the changes or corrections required for this
                            order.
                        </p>

                        {/* <Input
                            label="Changes / Requirements"
                            id="subject"
                            placeholder="Select the Subject"
                            inputStyle="w-full  max-h-[166px] "
                        /> */}
                        <LoginInput
                            className="w-full 2xl:w-full px-4"
                            id="requestRevisionRequirements"
                            name="requestRevisionRequirements"
                            label="Changes / Requirements"
                            type="textarea"
                            value={formData?.requestRevisionRequirements}
                            placeholder="Requirements or Changes"
                            error={touched?.requestRevisionRequirements && errors?.requestRevisionRequirements}
                            onChange={(e) => handleInputChange("requestRevisionRequirements", e.target.value)}
                            onBlur={() => handleBlur("requestRevisionRequirements", formData.requestRevisionRequirements)}
                            isRequired={true}
                            isFloatingLabel={false}
                            outerContainerStyle="w-full"
                        />

                        <h2 className="mt-[36px] mb-[12px] w-full font-inter text-secondary text-level-3 font-medium leading-6 text-start">
                            Additional Documents/ Reference Materials
                        </h2>
												{uploadFiles?.length > 0 &&
													<div className="w-full flex flex-wrap gap-2 lg:gap-4 m-2 lg:m-4">
														{
															uploadFiles.map((file, index) => {
																return <CustomFileIcon 
																					name={file.name} 
																					extension={file.name.split('.').pop().toLowerCase()}
																					downloadable={false}
																					removeFile={() => setUploadFiles(prev => prev.filter((f, i) => i !== index))}
																				/>
															})
														}
													</div>
												}
                            <DragUpload 
                                onFileUpload={handleDragUpload} 
                                isLoading={isUploadRefrencesToFirebaseLoading}
                                uploadFiles={uploadFiles}
                                dragText="Drag your file(s) to start uploading"
                                uploadText=""
                            />
                        <div className="flex w-full justify-between mt-6">
                            <ArrowButton
                                text="Back"
                                onClick={() => {dispatch(setSelectedFormType("system"));}}
                                width="auto"
                                height="44px"
                                iconDirection="left"
                                iconPosition="before"
                                classname=""
                            />
                            <LoginButton
                                text={
                                    isRequestRevision || isUploadRefrencesToFirebaseLoading ? 
                                    <ClipLoader
                                        loading={true}
                                        speedMultiplier={0.5}
                                        size={22}
                                        color="#60a5fa"
                                    />
                                    : "Request Revision"
                                }               
                                type="submit"
                                className="w-[80px] sm:w-[223px] h-[44px] flex items-center justify-center rounded-[5px] font-roboto text-[10px] sm:text-level-3 text-white font-semibold gap-[12px] px-[30px] py-[10px] transition-all duration-200"
                                onClick={() => {handleRequestRevision()}}
                                disabled = {isRequestRevision}
                            />
                        </div>
                    </div>
                </>
            ) : thread?.selectedFormType === "deliver-order" ? (
                <>
                    <div className="max-w-[800px] relative mx-auto flex flex-col items-center px-6 pt-6 pb-0 rounded-lg overflow-hidden"></div>
                </>
            ) : thread?.selectedFormType === "system" ? (
                <>
                    {thread?.selectedThreadNotifications?.map(
                        (group, indexmain ,arraymain) => {
                            return (
                                <>
                                    <div key={indexmain}  >
                                        {/* Display the date */}
                                        <div className="flex items-center justify-center my-4 mx-8">
                                            <div className="flex-grow h-px bg-[#E6E7EC]"></div>
                                            <div className="mx-4 font-inter font-medium text-level-5 text-gray">
                                                {group?._id}
                                            </div>
                                            <div className="flex-grow h-px bg-[#E6E7EC]"></div>
                                        </div>

                                        {/* Render system messages only once per date */}
                                        {group?.messages?.length > 0 && (
                                            <div className="system-messages z-5">
                                                {group?.messages?.map(
                                                    (message, index, array) => {

                                                        // there can be multiple revisions and multiple deliverables setGroupedInboxMessagesByDate. Hence we need to render only the related result for revision on deleiverables
                                                        let revisionReference = null;

                                                        // tracking related deliverables object
                                                        if(message.content === systemNotifications.ORDER_DELIVERED){
                                                            revisionReference = 
                                                            multipleRevisions?.length - 1  > -1 ? 
                                                            thread?.selectedOrder?.revisions[multipleRevisions?.length - 1]?._id : 
                                                            {
                                                                _id : null, 
                                                                obj: {
                                                                    deliveryNotes: thread?.selectedOrder?.deliveryNotes,
                                                                    finalDeliverables: thread?.selectedOrder?.finalDeliverables
                                                                }
                                                            }; 
                                                        }

                                                       // tracking related revision object
                                                        if(message.content === systemNotifications.REQUEST_REVISION){
                                                            revisionReference = thread?.selectedOrder?.revisions[multipleRevisions?.length]?._id;
                                                            multipleRevisions.push({obj: thread?.selectedOrder?.revisions[multipleRevisions?.length], _id: revisionReference})
                                                        }

                                                        return (
                                                            <SystemMessage
                                                                handleButtonClick={
                                                                    handleButtonClick
                                                                }
                                                                key={`system-notification${group?._id}-${index}`}
                                                                message={
                                                                    message.content
                                                                }
                                                                revisionReference={revisionReference}
                                                                providedSolution={thread?.selectedOrder?.complaint?.providedResolution}
                                                                date={
                                                                    message.createdAt
                                                                }
                                                                // time={message.time}
                                                                isLast={
                                                                    index ===
                                                                    array.length - 1 && indexmain === arraymain.length - 1
                                                                }
                                                                isLastWithinGroup = {
                                                                    index ===
                                                                    array.length - 1
                                                                }
                                                                isSingleInGroup={
                                                                    array.length ===
                                                                    1
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </>
                            );
                        }
                    )}
                </>
            ) : thread?.selectedFormType === "message" ? (
                <>
                    { 
                      isFetchUserOrderByRoomId || isFetchThreadById || isFetchUserThreadChatsLoading || isFetchUserThreadSystemNotificationsLoading ? (
                        <div className="flex flex-col flex-grow items-center justify-center w-full">
                            <ClipLoader
                                loading={true}
                                speedMultiplier={0.5}
                                size={82}
                                color="#60a5fa"
                            />
                        </div>
                    ) : Object.keys(groupedInboxMessagesByDate)?.length > 0 ? (
                        sortGroupdArray(
                            Object.keys(groupedInboxMessagesByDate)
                        )?.map((date, index) => {
                            return (
                                <>
                                    <div key={`inbox-messages-${date}`} className="mb-2">
                                        <div className="flex items-center justify-center my-4 mx-8">
                                            <div className="flex-grow h-px bg-[#E6E7EC]"></div>
                                            <div className="mx-4 font-inter font-medium text-level-5 text-gray">
                                                {date}
                                            </div>
                                            <div className="flex-grow h-px bg-[#E6E7EC]"></div>
                                        </div>
            
                                        {(
                                            groupedInboxMessagesByDate[date] || []
                                        )?.map((message, index) => (
                                            <div
                                                key={`inbox-message-${date}-${index}`}
                                                className={`flex mt-[20px]`}
                                            >
                                                <div className="flex w-full">
                                                    {/* flex-row-reverse */}
                                                    <div className={twMerge("flex w-full", tokenPayload?._id?.toString() === message?.sender?.toString() ? "flex-row-reverse" : "")}>
                                                        <img
                                                            src={
                                                                "https://static.vecteezy.com/system/resources/thumbnails/002/002/403/small/man-with-beard-avatar-character-isolated-icon-free-vector.jpg"
                                                            }
                                                            alt={message.sender}
                                                            className={`w-6 h-6 ml-2 rounded-full ${
                                                                message.sender === "Admin"
                                                                    ? "mt-[28px]"
                                                                    : "mt-[4px]"
                                                            }`}
                                                        />
                                                        {/* flex-row-reverse */}
                                                        <div className="flex flex-col mb-4 ml-4">
                                                            <div>
                                                                {message?.isAdmin && (
                                                                    <span className="font-inter font-normal text-secondary text-level-5 leading-[14.52px]">
                                                                        {"Admin"}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {/* rounded-tl-[16px] rounded-tr-none */}
                                                            <div
                                                                className={`font-inter font-gray font-normal text-level-4 leading-[20px] px-[18px] py-[12px] text-gray mt-[3px] inline-block rounded-b-[16px] ${
                                                                    message.sender?.toString() ===
                                                                    tokenPayload?._id?.toString()
                                                                        ? "bg-soft-blue text-primary"
                                                                        : "bg-soft-gray"
                                                                } ${tokenPayload?._id?.toString() === message?.sender?.toString() ? "rounded-tl-[16px] rounded-tr-none" : "rounded-tl-none rounded-tr-[16px]" }`}
                                                            >
                                                                {message.content}
                                                                {
                                                                    message?.attachments?.length > 0 && (
                                                                        <>
                                                                            <div className="flex flex-col gap-2">
                                                                                {
                                                                                    message?.attachments?.map((url, index) => {
                                                                                        return(
                                                                                            <>
                                                                                                <CustomFileIcon extension={getFileExtension(url)} key={index} url={url}/>
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                            <span className={`ml-[8px] font-inter text-gray italic text-[10px] leading-[20px]  py-[2px] ${tokenPayload?._id?.toString() === message?.sender?.toString() ? "text-left -translate-x-5" : "text-right translate-x-5"}`}>
                                                                {formatHH_MM_SS(
                                                                    message.createdAt
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* {unreadCount > 0 && (
                                        <>
                                            <div
                                                onClick={
                                                    scrollToFirstUnread
                                                }
                                                className="flex items-center cursor-pointer justify-center absolute bottom-[76px] right-6 w-8 h-8 rounded-full bg-[#E6E7EC]"
                                            >
                                                <img
                                                    src={icon}
                                                    alt="Scroll to unread"
                                                />
                                            </div>

                                            <div className="absolute flex justify-center items-center bottom-[98px] z-100 right-4 bg-blue-shades h-5 w-5 rounded-full">
                                                <p className="text-white font-inter text-level-4 leading-[21px]">
                                                    {unreadCount}
                                                </p>
                                            </div>
                                        </>
                                    )} */}

                                    <div
                                        className={`absolute  w-[98%] pr-6 bottom-[10px] ml-0 mr-[24px] flex bg-white rounded-[12px] ${
                                            [
                                                orderStatus.ORDER_DELIVERED,
                                                orderStatus.COMPLETED,
                                                orderStatus.RESOLVED,
                                            ].includes(
                                                thread
                                                    ?.selectedOrder
                                                    ?.status
                                            )
                                                ? "opacity-50 pointer-events-none"
                                                : ""
                                        }`}
                                    >
                                        <div className="relative justify-center mt-3 ">
                                        {!isUploadRefrencesToFirebaseLoading && 
                                                <img
                                                    src={attachicon}
                                                    alt="Attach"
                                                    className="w-[13px] h-auto mr-[16px] bg-white cursor-pointer"
                                                    title="Upload Attachments"
                                                    onClick={() => {
                                                        if (
                                                            ![
                                                                orderStatus.ORDER_DELIVERED,
                                                                orderStatus.COMPLETED,
                                                                orderStatus.RESOLVED,
                                                            ].includes(
                                                                thread
                                                                    ?.selectedOrder
                                                                    ?.status
                                                            )
                                                        ) {
                                                            document
                                                                .getElementById(
                                                                    "fileInput"
                                                                )
                                                                .click(); // Simulate file input click
                                                        }
                                                    }}
                                                />
                                            }
                                            {isUploadRefrencesToFirebaseLoading && <ClipLoader
                                                loading={true}
                                                speedMultiplier={1}
                                                size={22}
                                                color="#60a5fa"
                                            />}
                                            {!isUploadRefrencesToFirebaseLoading && <span className=" w-[12px] h-[12px] rounded-full bg-blue-400 text-[8px] font-inter text-white flex items-center justify-center absolute -top-2 right-3">
                                                {uploadFiles.length || 0}
                                            </span>}
                                            {!isUploadRefrencesToFirebaseLoading && <span className="w-[12px] h-[12px] rounded-full bg-slate-400 text-[8px] font-inter text-white flex items-center justify-center absolute top-2 right-1">
                                                <button
                                                    className="text-blue-500 underline flex justify-center items-center"
                                                    onClick={() => {
                                                        setUploadFiles([]);
                                                    }}
                                                    title="Clear All Attachments"
                                                >
                                                    <IoClose className="w-[8px] h-auto text-white" />
                                                </button>
                                            </span>}
                                            <input
                                                type="file"
                                                id="fileInput"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt,.csv, .zip, .rar"
                                                className="hidden"
                                                multiple // Allow multiple file selection
                                                onChange={(e) => {
                                                    if (e.target.files.length > 0) {
                                                        const files = Array.from(e.target.files);
                                                        setUploadFiles([...uploadFiles, ...files]);

                                                        // Reset the input value to allow re-uploading the same files
                                                        e.target.value = null;
                                                    }
                                                }}
                                            />
                                        </div>
																				
																				<div className="relative flex w-full mr-4 xl:mr-1">
																					{	uploadFiles?.length > 0 && 
																						<div className={`absolute z-5 w-[100%] top-0 translate-y-[-100%] max-h-[150px] overflow-y-auto border-[1px] border-medium-gray rounded-t-[12px] bg-[#FFFFFF] ${uploadFiles?.length > 0 ? "border-b-0 rounded-none": ""}`}>
																							<div className="flex flex-wrap  gap-2 lg:gap-4 m-2 lg:m-4">
																								{
																									uploadFiles.map((file, index) => {
																										return <CustomFileIcon 
																															name={file.name} 
																															extension={file.name.split('.').pop().toLowerCase()}
																															downloadable={false}
																															removeFile={() => setUploadFiles(prev => prev.filter((f, i) => i !== index))}
																														/>
																									})
																								}
																							</div>
																						</div>
																					}
																					<input
																							type="text"
																							placeholder="Type a message"
																							value={text}
																							onChange={(e) =>
																									setText(
																											e.target.value
																									)
																							}
																							disabled={[
																									orderStatus.ORDER_DELIVERED,
																									orderStatus.COMPLETED,
																									orderStatus.RESOLVED,
																							].includes(
																									thread
																											?.selectedOrder
																											?.status
																							)}
																							className={`flex-grow w-[98%] border border-t-medium-gray border-b-medium-gray border-r-medium-gray border-l-medium-gray rounded-l-[12px] px-4 py-2 focus:outline-none focus:border-[#CCCED2] font-inter text-level-4 leading-[21px] text-gray 
													disabled:bg-soft-gray disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed
													${uploadFiles?.length > 0 && "border-t-0 border-r-0 rounded-tl-none"}`}
																							onKeyUp={e => {
																									if(e.key === "Enter"){
																											handleSendMessage();
																									}
																							}}
																					/>
																					<button
																							onClick={
																									handleSendMessage
																							}
																							disabled={[
																									orderStatus.ORDER_DELIVERED,
																									orderStatus.COMPLETED,
																									orderStatus.RESOLVED,
																							].includes(
																									thread
																											?.selectedOrder
																											?.status
																							)}
																							className={`border border-t-medium-gray border-b-medium-gray border-r-medium-gray border-l-medium-gray text-gray-700 px-4 py-2 rounded-r-[12px] focus:outline-none focus:border-[#CCCED2]
																									disabled:bg-soft-gray disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed
																									${uploadFiles?.length > 0 && "border-t-0 border-l-0 rounded-tr-none"}`}
																							>
                                                                                            {isUploadRefrencesToFirebaseLoading && (
                                                                                                <ClipLoader
                                                                                                    loading={true}
                                                                                                    speedMultiplier={1}
                                                                                                    size={22}
                                                                                                    color="#60a5fa"
                                                                                                />
                                                                                            )}
                                                                                            {!isUploadRefrencesToFirebaseLoading && (
                                                                                                <img
                                                                                                src={sendicon}
                                                                                                alt="Send Icon"
																							/>
                                                                                            )}
																					</button>
																				</div>
                                    </div>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            );
                        })
                    ) : (
                        <div className="flex flex-col font-inter justify-center items-center h-[60vh]">
                            <img
                                src={waiting} // Replace with your waiting image URL
                                alt="Waiting for messages"
                                className="w-[250px] h-auto"
                            />
                            <h1 className="text-level-2 font-roboto text-primary font-semibold">No Messages , yet</h1>
                            <p className=" min-w-[20vh]  sm:w-[40vh] lg:w-[60vh] text-level-3 text-gray mt-2 text-center">Your inbox is currently empty. Once you receive messages, they’ll appear here.</p>
                            {thread?.selectedOrder?.status !== orderStatus.PENDING_PAYMENT && (
                                <div
                                    className={`absolute  w-[98%] pr-6 bottom-[10px] ml-12 mr-[24px] flex bg-white rounded-[12px] ${
                                        [
                                            orderStatus.ORDER_DELIVERED,
                                            orderStatus.COMPLETED,
                                            orderStatus.RESOLVED,
                                        ].includes(
                                            thread
                                                ?.selectedOrder
                                                ?.status
                                        )
                                            ? "opacity-50 pointer-events-none"
                                            : ""
                                    }`}
                                >
                                    <div className="relative justify-center mt-3 ">
                                    {!isUploadRefrencesToFirebaseLoading && 
                                            <img
                                                src={attachicon}
                                                alt="Attach"
                                                className="w-[13px] h-auto mr-[16px] bg-white cursor-pointer"
                                                title="Upload Attachments"
                                                onClick={() => {
                                                    if (
                                                        ![
                                                            orderStatus.ORDER_DELIVERED,
                                                            orderStatus.COMPLETED,
                                                            orderStatus.RESOLVED,
                                                        ].includes(
                                                            thread
                                                                ?.selectedOrder
                                                                ?.status
                                                        )
                                                    ) {
                                                        document
																													.getElementById(
																															"fileInput"
																													)
																													.click(); // Simulate file input click
                                                    }
                                                }}
                                            />
                                        }
                                        {isUploadRefrencesToFirebaseLoading && <ClipLoader
                                            loading={true}
                                            speedMultiplier={1}
                                            size={22}
                                            color="#60a5fa"
                                        />}
                                        {!isUploadRefrencesToFirebaseLoading && <span className=" w-[12px] h-[12px] rounded-full bg-blue-400 text-[8px] font-inter text-white flex items-center justify-center absolute -top-2 right-3">
                                            {uploadFiles.length || 0}
                                        </span>}
                                        {!isUploadRefrencesToFirebaseLoading && <span className="w-[12px] h-[12px] rounded-full bg-slate-400 text-[8px] font-inter text-white flex items-center justify-center absolute top-2 right-1">
                                            <button
                                                className="text-blue-500 underline flex justify-center items-center"
                                                onClick={() => {
                                                    setUploadFiles([]);
                                                }}
                                                title="Clear All Attachments"
                                            >
                                                <IoClose className="w-[8px] h-auto text-white" />
                                            </button>
                                        </span>}
                                        <input
                                            type="file"
                                            id="fileInput"
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt,.csv, .zip, .rar"
                                            className="hidden"
                                            multiple // Allow multiple file selection
                                            onChange={(e) => {
                                                if (e.target.files.length > 0) {
                                                    const files = Array.from(e.target.files);
                                                    setUploadFiles([...uploadFiles, ...files]);
                                                }

                                                // Reset the input value to allow re-uploading the same files
                                                e.target.value = null;
                                            }}
                                        />
                                    </div>
																					
                                    <div className="relative flex w-full mr-4 xl:mr-1">
																					{	uploadFiles?.length > 0 && 
																						<div className={`absolute z-5 w-[100%] top-0 translate-y-[-100%] max-h-[150px] overflow-y-auto border-[1px] border-medium-gray rounded-t-[12px] bg-[#FFFFFF] ${uploadFiles?.length > 0 ? "border-b-0 rounded-none": ""}`}>
																							<div className="flex flex-wrap  gap-2 lg:gap-4 m-2 lg:m-4">
																								{
																									uploadFiles.map((file, index) => {
																										return <CustomFileIcon 
																															name={file.name} 
																															extension={file.name.split('.').pop().toLowerCase()}
																															downloadable={false}
																															removeFile={() => setUploadFiles(prev => prev.filter((f, i) => i !== index))}
																														/>
																									})
																								}
																							</div>
																						</div>
																					}
																					<input
																							type="text"
																							placeholder="Type a message"
																							value={text}
																							onChange={(e) =>
																									setText(
																											e.target.value
																									)
																							}
																							disabled={[
																									orderStatus.ORDER_DELIVERED,
																									orderStatus.COMPLETED,
																									orderStatus.RESOLVED,
																							].includes(
																									thread
																											?.selectedOrder
																											?.status
																							)}
																							className={`flex-grow w-[98%] border border-t-medium-gray border-b-medium-gray border-r-medium-gray border-l-medium-gray rounded-l-[12px] px-4 py-2 focus:outline-none focus:border-[#CCCED2] font-inter text-level-4 leading-[21px] text-gray 
													disabled:bg-soft-gray disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed
													${uploadFiles?.length > 0 && "border-t-0 border-r-0 rounded-tl-none"}`}
																							onKeyUp={e => {
																									if(e.key === "Enter"){
																											handleSendMessage();
																									}
																							}}
																					/>
																					<button
																							onClick={
																									handleSendMessage
																							}
																							disabled={[
																									orderStatus.ORDER_DELIVERED,
																									orderStatus.COMPLETED,
																									orderStatus.RESOLVED,
																							].includes(
																									thread
																											?.selectedOrder
																											?.status
																							)}
																							className={`border border-t-medium-gray border-b-medium-gray border-r-medium-gray border-l-medium-gray text-gray-700 px-4 py-2 rounded-r-[12px] focus:outline-none focus:border-[#CCCED2]
																									disabled:bg-soft-gray disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed
																									${uploadFiles?.length > 0 && "border-t-0 border-l-0 rounded-tr-none"}`}
																							>
                                                                                            {isUploadRefrencesToFirebaseLoading && (
                                                                                                <ClipLoader
                                                                                                    loading={true}
                                                                                                    speedMultiplier={1}
                                                                                                    size={22}
                                                                                                    color="#60a5fa"
                                                                                                />
                                                                                            )}
                                                                                            {!isUploadRefrencesToFirebaseLoading && (
                                                                                                <img
                                                                                                    src={sendicon}
                                                                                                    alt="Send Icon"
																							    />
                                                                                            )}

																					</button>
																				</div>
                                </div>
                            )}
                        </div>
                    )
                    }
                </>
            ): (
                <></>
            )}
            <div ref={messageEndRef} />
        </div>
    );
};

export default MessageList;